export default __webpack_public_path__ + "static/media/calculadora_PSU-4.1e22a774.png";